import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'applicability' })
export class ApplicabilityFilterPipe implements PipeTransform {
  transform(values: any[], filter: string): any[] {
    if (!filter || filter.length === 0) {
      return values;
    }

    if (values.length === 0) {
      return values;
    }

    return values.filter((value: { value:string, label:string, lcdvcharacterstics?:any[] }) => {
        if(value.lcdvcharacterstics==undefined){
            value.lcdvcharacterstics=[];
        }
      const valueFound =
        value.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
      const labelFound =
        value.label.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
      const lcdvFound = 
        value.lcdvcharacterstics
          .filter(lcdv => lcdv.lcdvCode.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || lcdv.lcdvLabel.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
          .length;
      if (valueFound || labelFound || lcdvFound) {
        return value;
      }
    });
  }
}
